import { render, staticRenderFns } from "./Locais.vue?vue&type=template&id=64d682e1&scoped=true&"
import script from "./Locais.vue?vue&type=script&lang=js&"
export * from "./Locais.vue?vue&type=script&lang=js&"
import style0 from "./Locais.vue?vue&type=style&index=0&id=64d682e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d682e1",
  null
  
)

export default component.exports